import type { Befund } from "@gui-creator/gemeinsam";
import { CircleAlert, CircleCheck, TriangleAlert } from "lucide-react";
import { Abschnitt } from "../eigenschaften/gemeinsam.tsx";
import { befundZahlen } from "./befunde.ts";
import "./planung.css";

export function Pruefliste({ befunde, onSlot }: { befunde: Befund[]; onSlot: (i: number) => void }) {
  const z = befundZahlen(befunde);
  const sortiert = [...befunde].sort((a, b) => (a.stufe === b.stufe ? 0 : a.stufe === "fehler" ? -1 : 1));
  return (
    <Abschnitt
      region
      titel={
        <>
          Prüfung <span className={`pruef-zahl${z.fehler ? " pruef-zahl-fehler" : z.warnungen ? " pruef-zahl-warnung" : ""}`}>{z.text}</span>
        </>
      }
    >
      {befunde.length === 0 ? (
        <p className="pruef-gut">
          <CircleCheck size={14} aria-hidden="true" /> Nichts zu beanstanden.
        </p>
      ) : (
        <ul className="befunde">
          {sortiert.map((b, i) => {
            const inhalt = (
              <>
                {b.stufe === "fehler" ? <CircleAlert size={14} className="befund-fehler" aria-label="Fehler" /> : <TriangleAlert size={14} className="befund-warnung" aria-label="Warnung" />}
                <span>
                  <span className="befund-ort">{b.ort}</span> {b.meldung}
                </span>
              </>
            );
            return (
              <li key={i}>
                {b.slot !== undefined ? (
                  <button type="button" className="befund" onClick={() => onSlot(b.slot!)} title={`Zu Slot ${b.slot} springen`}>
                    {inhalt}
                  </button>
                ) : (
                  <div className="befund">{inhalt}</div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </Abschnitt>
  );
}
